import { palettes } from '@backstage/theme';
import { PaletteOptions } from '@mui/material/styles';
import { getModeTokens, ThemeVariant } from './tokens';

export const createMeltwaterPalette = (
  variant: ThemeVariant,
): PaletteOptions => {
  const tokens = getModeTokens(variant);

  return {
    ...palettes[variant],
    primary: {
      main: tokens.primaryMain,
      light: tokens.primaryLight,
      dark: tokens.primaryDark,
      contrastText: tokens.textContrast,
    },
    secondary: {
      main: tokens.secondaryMain,
      light: tokens.secondaryLight,
      dark: tokens.secondaryDark,
      contrastText: tokens.textContrast,
    },
    background: {
      default: tokens.background,
      paper: tokens.paper,
    },
    text: {
      primary: tokens.textPrimary,
      secondary: tokens.textSecondary,
      disabled: tokens.textMuted,
    },
    divider: tokens.border,
    border: tokens.border,
    textContrast: tokens.textContrast,
    textSubtle: tokens.textMuted,
    textVerySubtle: tokens.textSecondary,
    link: tokens.primaryMain,
    linkHover: tokens.primaryDark,
    errorBackground: variant === 'dark' ? '#331318' : '#FCECED',
    warningBackground: variant === 'dark' ? '#362108' : '#FFF2DE',
    infoBackground: variant === 'dark' ? '#10232C' : '#EAF5FB',
    errorText: variant === 'dark' ? '#FFB3BD' : '#A32439',
    warningText: variant === 'dark' ? '#FFD79B' : '#8A5A00',
    infoText: variant === 'dark' ? '#B6E7F7' : '#005A7A',
    navigation: {
      background: tokens.navigationBackground,
      indicator: tokens.navigationIndicator,
      color: tokens.navigationColor,
      selectedColor: tokens.navigationSelected,
      navItem: {
        hoverBackground: tokens.navigationHover,
      },
      submenu: {
        background: tokens.navigationSubmenu,
      },
    },
    tabbar: {
      indicator: tokens.navigationIndicator,
    },
    pinSidebarButton: {
      icon: tokens.navigationBackground,
      background: tokens.navigationIndicator,
    },
    banner: {
      info: '#0073B8',
      error: '#D64253',
      text: tokens.textContrast,
      link: tokens.textContrast,
      closeButtonColor: tokens.textContrast,
      warning: '#D08A00',
    },
    success: {
      main: '#2B9B67',
      light: '#E8F6EF',
      dark: '#166542',
      contrastText: tokens.textContrast,
    },
    info: {
      main: '#1A8AC7',
      light: '#EAF5FB',
      dark: '#005A7A',
      contrastText: tokens.textContrast,
    },
    warning: {
      main: '#D08A00',
      light: '#FFF2DE',
      dark: '#8A5A00',
      contrastText: tokens.textContrast,
    },
    error: {
      main: '#D64253',
      light: '#FCECED',
      dark: '#A32439',
      contrastText: tokens.textContrast,
    },
  };
};
